/* ============================================================
   FLUX 取扱店舗一覧 / dealers-list.js （最終版）
   - 検索: 店舗名 / 住所 / 都道府県
   - 絞込: 都道府県 / 種類(bindings/boots) / モデル
   - 表示: リスト or 地図 (Google Maps)
   - データソース: Storefront API → 静的JSON → インライン の順にフォールバック
   ============================================================ */
(function () {
  'use strict';

  const PREF_ORDER = [
    '北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県',
    '茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県',
    '新潟県','富山県','石川県','福井県','山梨県','長野県',
    '岐阜県','静岡県','愛知県','三重県',
    '滋賀県','京都府','大阪府','兵庫県','奈良県','和歌山県',
    '鳥取県','島根県','岡山県','広島県','山口県',
    '徳島県','香川県','愛媛県','高知県',
    '福岡県','佐賀県','長崎県','熊本県','大分県','宮崎県','鹿児島県','沖縄県'
  ];
  const prefIndex = (p) => { const i = PREF_ORDER.indexOf(p); return i === -1 ? 999 : i; };

  // Storefront API GraphQL
  async function fetchFromStorefrontAPI(shopDomain, token) {
    const endpoint = `https://${shopDomain}/api/2024-07/graphql.json`;
    const query = `
      query GetStores($cursor: String) {
        metaobjects(type: "store", first: 250, after: $cursor) {
          nodes { handle fields { key value } }
          pageInfo { hasNextPage endCursor }
        }
      }`;
    const all = [];
    let cursor = null;
    let safety = 0;
    while (safety < 10) {
      safety++;
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query, variables: { cursor } })
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      if (json.errors) throw new Error('GraphQL: ' + JSON.stringify(json.errors));
      const data = json.data && json.data.metaobjects;
      if (!data) break;
      data.nodes.forEach((node) => {
        const obj = { id: node.handle };
        node.fields.forEach((f) => { obj[f.key] = f.value; });
        try { obj.bindings = obj.bindings ? JSON.parse(obj.bindings) : []; } catch (e) { obj.bindings = []; }
        try { obj.boots = obj.boots ? JSON.parse(obj.boots) : []; } catch (e) { obj.boots = []; }
        obj.lat = obj.latitude ? parseFloat(obj.latitude) : null;
        obj.lng = obj.longitude ? parseFloat(obj.longitude) : null;
        all.push(obj);
      });
      if (!data.pageInfo.hasNextPage) break;
      cursor = data.pageInfo.endCursor;
    }
    return all;
  }

  async function init(root) {
    let stores = [];

    const shopDomain = root.dataset.shopDomain || '';
    const sfToken = root.dataset.storefrontToken || '';
    const dataUrl = root.dataset.dataUrl || '';

    if (shopDomain && sfToken) {
      try {
        console.log('[dealers] fetching via Storefront API');
        stores = await fetchFromStorefrontAPI(shopDomain, sfToken);
        console.log('[dealers] Storefront API loaded', stores.length, 'stores');
      } catch (e) {
        console.error('[dealers] Storefront API failed, will fallback:', e);
        stores = [];
      }
    }

    if (stores.length === 0 && dataUrl) {
      try {
        console.log('[dealers] fetching static JSON:', dataUrl);
        const r = await fetch(dataUrl);
        if (r.ok) {
          stores = await r.json();
          console.log('[dealers] static JSON loaded', stores.length, 'stores');
        }
      } catch (e) {
        console.error('[dealers] static JSON fetch error', e);
      }
    }

    if (stores.length === 0) {
      const dataEl = root.querySelector('#dealers-data');
      if (dataEl) {
        try { stores = JSON.parse(dataEl.textContent || '[]'); } catch (e) {}
      }
    }

    if (stores.length === 0) console.warn('[dealers] No stores loaded');

    stores.forEach((s) => {
      s.bindings = Array.isArray(s.bindings) ? s.bindings : [];
      s.boots = Array.isArray(s.boots) ? s.boots : [];
      s._search = [s.name || '', s.address || '', s.prefecture || ''].join(' ').toLowerCase();
    });

    stores.sort((a, b) => {
      const d = prefIndex(a.prefecture) - prefIndex(b.prefecture);
      if (d !== 0) return d;
      return (a.name || '').localeCompare(b.name || '', 'ja');
    });

    const els = {
      q: root.querySelector('#dealers-q'),
      clear: root.querySelector('#dealers-clear'),
      pref: root.querySelector('#dealers-pref'),
      type: root.querySelector('#dealers-type'),
      model: root.querySelector('#dealers-model'),
      reset: root.querySelector('#dealers-reset'),
      count: root.querySelector('#dealers-count'),
      grid: root.querySelector('#dealers-grid'),
      empty: root.querySelector('#dealers-empty'),
      viewBtns: root.querySelectorAll('[data-view]'),
      paneList: root.querySelector('#dealers-pane-list'),
      paneMap: root.querySelector('#dealers-pane-map'),
      mapEl: root.querySelector('#dealers-map')
    };

    const showMap = root.dataset.showMap === 'true';
    const mapsKey = root.dataset.mapsKey || '';

    const usedPrefs = Array.from(new Set(stores.map((s) => s.prefecture).filter(Boolean)));
    usedPrefs.sort((a, b) => prefIndex(a) - prefIndex(b));
    usedPrefs.forEach((p) => {
      const opt = document.createElement('option');
      opt.value = p; opt.textContent = p;
      els.pref.appendChild(opt);
    });

    const allBindings = new Set();
    const allBoots = new Set();
    stores.forEach((s) => {
      s.bindings.forEach((m) => allBindings.add(m));
      s.boots.forEach((m) => allBoots.add(m));
    });
    const sortModel = (a, b) => a.localeCompare(b, 'en');
    const BIND_LIST = Array.from(allBindings).sort(sortModel);
    const BOOT_LIST = Array.from(allBoots).sort(sortModel);

    function updateModelOptions() {
      const type = state.type;
      const current = state.model;
      let list;
      if (type === 'bindings') list = BIND_LIST.map((m) => ['bindings', m]);
      else if (type === 'boots') list = BOOT_LIST.map((m) => ['boots', m]);
      else list = [].concat(
        BIND_LIST.map((m) => ['bindings', m]),
        BOOT_LIST.map((m) => ['boots', m])
      );
      els.model.innerHTML = '<option value="">すべて</option>';
      let lastGroup = null;
      list.forEach(([cat, m]) => {
        if (cat !== lastGroup && !type) {
          const og = document.createElement('optgroup');
          og.label = cat === 'bindings' ? 'バインディング' : 'ブーツ';
          og.dataset.cat = cat;
          els.model.appendChild(og);
          lastGroup = cat;
        }
        const opt = document.createElement('option');
        opt.value = cat + '::' + m;
        opt.textContent = m;
        const parent = !type
          ? els.model.querySelector('optgroup[data-cat="' + cat + '"]')
          : els.model;
        parent.appendChild(opt);
      });
      if (current) {
        const opt = els.model.querySelector('option[value="' + CSS.escape(current) + '"]');
        if (opt) els.model.value = current;
        else state.model = '';
      }
    }

    const initialModel = root.dataset.initialModel || '';
    const initialType  = root.dataset.initialType || '';
    const state = { q: '', pref: '', type: initialType, model: '' };
    if (els.type) els.type.value = initialType;
    updateModelOptions();
    if (initialModel) {
      const findInCat = (cat) => Array.from(els.model.options).find((o) => o.value === cat + '::' + initialModel);
      let target = null;
      if (initialType) target = findInCat(initialType);
      if (!target) target = findInCat('bindings') || findInCat('boots');
      if (target) {
        els.model.value = target.value;
        state.model = target.value;
      }
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get('q')) { state.q = params.get('q'); els.q.value = state.q; }
    if (params.get('pref')) { state.pref = params.get('pref'); els.pref.value = state.pref; }
    if (params.get('type')) { state.type = params.get('type'); els.type.value = state.type; updateModelOptions(); }
    if (params.get('model')) {
      const v = params.get('model');
      const cand = ['bindings::' + v, 'boots::' + v];
      const found = cand.find((c) => Array.from(els.model.options).some((o) => o.value === c));
      if (found) { state.model = found; els.model.value = found; }
    }

    // Google Maps state (TDZ回避のため前方宣言)
    let mapInstance = null;
    let markers = [];
    let infoWindow = null;

    function buildCard(s) {
      const li = document.createElement('li');
      li.className = 'dealers-card';
      const mapsQuery = encodeURIComponent([s.prefecture, s.address, s.name].filter(Boolean).join(' '));
      const matchModel = state.model ? state.model.split('::')[1] : null;
      const matchCat = state.model ? state.model.split('::')[0] : null;

      const filterCat = matchCat || state.type || '';
      const showBindings = !filterCat || filterCat === 'bindings';
      const showBoots = !filterCat || filterCat === 'boots';

      const bindings = (showBindings && s.bindings.length) ? `
        <div class="dealers-card__models-row dealers-card__models-row--bindings">
          <span class="dealers-card__models-label">BIND</span>
          ${s.bindings.map((m) => `<span class="dealers-card__model${matchCat === 'bindings' && m === matchModel ? ' is-match' : ''}">${escapeHTML(m)}</span>`).join('')}
        </div>` : '';
      const boots = (showBoots && s.boots.length) ? `
        <div class="dealers-card__models-row dealers-card__models-row--boots">
          <span class="dealers-card__models-label">BOOTS</span>
          ${s.boots.map((m) => `<span class="dealers-card__model${matchCat === 'boots' && m === matchModel ? ' is-match' : ''}">${escapeHTML(m)}</span>`).join('')}
        </div>` : '';

      li.innerHTML = `
        ${s.prefecture ? `<span class="dealers-card__pref">${escapeHTML(s.prefecture)}</span>` : ''}
        <h3 class="dealers-card__name">${escapeHTML(s.name)}</h3>
        <p class="dealers-card__address">${escapeHTML([s.postal_code, s.address].filter(Boolean).join(' '))}</p>
        ${s.phone ? `<a class="dealers-card__phone" href="tel:${escapeAttr(s.phone.replace(/[^0-9+\-]/g, ''))}">${escapeHTML(s.phone)}</a>` : ''}
        ${(bindings || boots) ? `<div class="dealers-card__models">${bindings}${boots}</div>` : ''}
        <a class="dealers-card__map-link" href="https://www.google.com/maps/search/?api=1&query=${mapsQuery}" target="_blank" rel="noopener">地図で見る ↗</a>
      `;
      return li;
    }

    function render() {
      const filtered = stores.filter(matches);
      els.grid.replaceChildren(...filtered.map(buildCard));
      els.count.textContent = filtered.length;
      els.empty.hidden = filtered.length !== 0;

      const hasFilter = state.q || state.pref || state.type || state.model;
      els.reset.hidden = !hasFilter;
      els.clear.hidden = !state.q;

      if (mapInstance) renderMarkers(filtered);
    }

    function matches(s) {
      if (state.q) {
        if (s._search.indexOf(state.q.toLowerCase()) === -1) return false;
      }
      if (state.pref && s.prefecture !== state.pref) return false;
      if (state.model) {
        const [cat, m] = state.model.split('::');
        if (!(s[cat] || []).includes(m)) return false;
      } else if (state.type) {
        if (!(s[state.type] || []).length) return false;
      }
      return true;
    }

    // イベント
    let qTimer = null;
    els.q.addEventListener('input', (e) => {
      clearTimeout(qTimer);
      qTimer = setTimeout(() => {
        state.q = e.target.value.trim();
        render();
      }, 150);
    });
    els.clear.addEventListener('click', () => {
      els.q.value = ''; state.q = ''; render(); els.q.focus();
    });
    els.pref.addEventListener('change', (e) => { state.pref = e.target.value; render(); });
    els.type.addEventListener('change', (e) => {
      state.type = e.target.value;
      state.model = '';
      updateModelOptions();
      render();
    });
    els.model.addEventListener('change', (e) => { state.model = e.target.value; render(); });
    els.reset.addEventListener('click', () => {
      state.q = ''; state.pref = ''; state.type = ''; state.model = '';
      els.q.value = ''; els.pref.value = ''; els.type.value = '';
      updateModelOptions();
      render();
    });

    // ビュー切替
    els.viewBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        els.viewBtns.forEach((b) => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active);
        });
        if (view === 'list') {
          els.paneList.classList.add('is-active'); els.paneList.hidden = false;
          if (els.paneMap) { els.paneMap.classList.remove('is-active'); els.paneMap.hidden = true; }
        } else if (view === 'map') {
          if (els.paneMap) { els.paneMap.classList.add('is-active'); els.paneMap.hidden = false; }
          els.paneList.classList.remove('is-active'); els.paneList.hidden = true;
          ensureMap();
        }
      });
    });

    render();

    // Google Maps
    function ensureMap() {
      if (!showMap || !mapsKey || mapInstance) return;
      if (window.google && window.google.maps) { initMap(); return; }
      if (window.__dealersMapLoading) return;
      window.__dealersMapLoading = true;
      window.__dealersMapInit = function () { initMap(); };
      const s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(mapsKey) + '&callback=__dealersMapInit&language=ja&region=JP';
      s.async = true;
      s.defer = true;
      document.head.appendChild(s);
    }

    function initMap() {
      const g = window.google.maps;
      mapInstance = new g.Map(els.mapEl, {
        center: { lat: 36.5, lng: 138 },
        zoom: 5,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true
      });
      infoWindow = new g.InfoWindow();
      renderMarkers(stores.filter(matches));
    }

    function renderMarkers(list) {
      if (!mapInstance || !window.google) return;
      const g = window.google.maps;
      markers.forEach((m) => m.setMap(null));
      markers = [];
      const bounds = new g.LatLngBounds();
      let plotted = 0;

      list.forEach((s) => {
        if (typeof s.lat !== 'number' || typeof s.lng !== 'number') return;
        const pos = { lat: s.lat, lng: s.lng };
        const marker = new g.Marker({ position: pos, map: mapInstance, title: s.name });
        marker.addListener('click', () => {
          const tel = s.phone ? `<p class="dealers-infowindow__tel"><a href="tel:${escapeAttr(s.phone.replace(/[^0-9+\-]/g, ''))}">${escapeHTML(s.phone)}</a></p>` : '';
          infoWindow.setContent(`
            <div class="dealers-infowindow">
              <p class="dealers-infowindow__name">${escapeHTML(s.name)}</p>
              <p class="dealers-infowindow__addr">${escapeHTML([s.prefecture, s.address].filter(Boolean).join(''))}</p>
              ${tel}
            </div>
          `);
          infoWindow.open(mapInstance, marker);
        });
        markers.push(marker);
        bounds.extend(pos);
        plotted++;
      });
      if (plotted === 1) { mapInstance.setCenter(bounds.getCenter()); mapInstance.setZoom(14); }
      else if (plotted > 1) { mapInstance.fitBounds(bounds, 40); }
    }
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) { return escapeHTML(s); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('[data-dealers]').forEach(init);
    });
  } else {
    document.querySelectorAll('[data-dealers]').forEach(init);
  }
})();
